import React, { useState, useEffect } from 'react';
import { useRequest } from 'umi';
import styles from '../css/campCSS.less';
import { MarkingDetailsVO, MarkingVO } from '@/types/camp/admin/markingType';
import { Skeleton, Empty } from 'antd';
import Editor from '@digit-fe/digit-editor-new';
import { listSubjectiveQuestion } from '@/utils/requests/camp/requests_marking';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

interface Props {
  baseInfo?: MarkingVO;
  studyNodeId: string;
  setHash?: (hash: number) => void;
}

const QuestionMarkingView: React.FC<Props> = ({ studyNodeId, baseInfo, setHash }) => {
  const [dataSource, setDataSource] = useState<MarkingDetailsVO[]>([]);
  const [expandedIndexes, setExpandedIndexes] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  // 获取主观题列表
  const { run: listSubjectiveRequest } = useRequest(
    () => {
      return listSubjectiveQuestion(studyNodeId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setDataSource(res);
        setLoading(false);
      },
    },
  );
  useEffect(() => {
    listSubjectiveRequest();
  }, []);

  // 更新toggleItem函数以支持多选
  const toggleItem = (index: string) => {
    let newExpandedIndexes = [...expandedIndexes];
    const indexPosition = expandedIndexes.indexOf(index);

    if (indexPosition > -1) {
      // 如果已存在，则移除它
      newExpandedIndexes = newExpandedIndexes.filter((i) => i !== index);
    } else {
      // 否则添加新的索引
      newExpandedIndexes.push(index);
    }

    // 更新状态
    setExpandedIndexes(newExpandedIndexes);
  };

  const zhedie = (index: any) => {
    if (expandedIndexes.includes(index)) {
      return (
        <div className="col008 flex_1">
          <span className="f14" style={{ marginRight: 6 }}>
            折叠
          </span>
          <UpOutlined className="f12" />
        </div>
      );
    } else {
      return (
        <div className="col008 flex_1">
          <span className="f14" style={{ marginRight: 6 }}>
            展开
          </span>
          <DownOutlined className="f12" />
        </div>
      );
    }
  };

  return (
    <>
      {loading && (
        <div style={{ padding: 24 }}>
          <div style={{ marginBottom: 24, padding: '10px 0' }}>
            <Skeleton.Button active block style={{ height: 40 }} />
          </div>

          <div className="flex_0">
            <div style={{ width: 120 }}>
              <Skeleton.Image active />
            </div>
            <div style={{ flex: 1 }}>
              <Skeleton active loading={loading} paragraph={{ rows: 10 }} />
            </div>
          </div>
        </div>
      )}

      {!loading && (
        <div>
          <div style={{ padding: '12px 20px 12px 20px', borderBottom: '1px solid #E5E5E5' }}>
            <div className="f16">{`[${baseInfo?.batchName || baseInfo?.className}] ${
              baseInfo?.campName || baseInfo?.projectName
            } - ${baseInfo?.nodeName}`}</div>
            <div className="f12 col808">{baseInfo?.username} 的作业</div>
          </div>

          <div className={styles.marking_form} style={{ paddingBottom: 24 }}>
            {dataSource && dataSource?.length > 0 ? (
              dataSource.map((item, index) => (
                <div className={styles.marking_form_item}>
                  <div className="pd20 edit_no_pd" style={{ position: 'relative' }}>
                    <div
                      className="flex_3"
                      onClick={() => toggleItem(`timu${index}`)}
                      style={{ cursor: 'pointer', paddingBottom: 6 }}
                    >
                      第 {index + 1}/{dataSource?.length} 题：
                      {zhedie(`timu${index}`)}
                    </div>
                    <div
                      className={
                        expandedIndexes.includes(`timu${index}`) ? styles.show : styles.hide
                      }
                    >
                      <div className="f16 fw600" style={{ paddingBottom: 6 }}>
                        {item.title}
                      </div>
                      <Editor
                        key={`edit_description_${index}`}
                        content={item.description && JSON.parse(item.description)}
                        editable={false}
                        titleProps={{ showTitle: false }}
                        catalogProps={{ showCatalog: false }}
                      />
                    </div>
                  </div>

                  {item.analysis && (
                    <div className="edit_no_pd">
                      <div className="com_line"></div>
                      <div style={{ padding: '0px 20px' }}>
                        <div
                          className="flex_3"
                          onClick={() => toggleItem(`jiexi${index}`)}
                          style={{ cursor: 'pointer' }}
                        >
                          题目解析：
                          {zhedie(`jiexi${index}`)}
                        </div>
                      </div>
                      <div
                        style={{ padding: '16px 20px 0 20px' }}
                        className={
                          expandedIndexes.includes(`jiexi${index}`) ? styles.show : styles.hide1
                        }
                      >
                        <Editor
                          key={`analysis_${index}`}
                          content={item.analysis && JSON.parse(item.analysis)}
                          editable={false}
                          titleProps={{ showTitle: false }}
                          catalogProps={{ showCatalog: false }}
                        />
                      </div>
                    </div>
                  )}
                  <div className="com_line"></div>
                  <div style={{ paddingLeft: 16 }}>学员答案：</div>
                  <div className="pd20 edit_no_pd">
                    <Editor
                      key={`analysis_${index}`}
                      content={item.studentAnswer && JSON.parse(item.studentAnswer)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </div>

                  <div className="com_line"></div>
                  <div style={{ paddingLeft: 20 }}>
                    <div className="fw600" id={`score_${item.id}_score`}>
                      本题得分：
                      <span className="colff7">
                        {item.score}/{item.rewardScore}
                      </span>
                    </div>
                  </div>
                  <div className="pd20">
                    <div className="fw600" style={{ paddingBottom: 6 }}>
                      评语
                    </div>
                    <Editor
                      key={`edit_${item.id}`}
                      content={item.comment && JSON.parse(item.comment)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </div>
                </div>
              ))
            ) : (
              <Empty style={{ margin: '40px 0 20px' }} />
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default QuestionMarkingView;
